$('.js-coll-slider').slick({
  infinite: true,
  dots:true,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1
});
const detail_accordion = document.querySelector('details.js-accordion')
if(detail_accordion)
{
  detail_accordion.addEventListener("toggle", (event) => {
  if (detail_accordion.open) {
   document.querySelector('.overlay-body').classList.add('active')
  } else {
     document.querySelector('.overlay-body').classList.remove('active')
    /* the element was toggled closed */
  }
});
}

const overlay_body = document.querySelector('.overlay-body')
if(overlay_body){
  overlay_body.addEventListener('click',(event)=>{
  console.log('click')
  const detail_accordion = document.querySelector('details.js-accordion');
  if(detail_accordion.open && overlay_body.classList.contains('active')){
    overlay_body.classList.remove('active')
    detail_accordion.removeAttribute('open')
  }
})
}


const collapse_btn = document.querySelector('.span-wrap-box')
if(collapse_btn){
  collapse_btn.addEventListener('click',(e)=>{
  const parent_ele = e.target.closest('.icons-row__slider ')
  parent_ele.classList.toggle('active')
})
}
